export const LOAD_CATEGORIES = "dicts/loadCategories";
export const LOAD_REGIONS = "dicts/loadRegions";
export const LOAD_DICTS = "dicts/loadDicts";
